import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getSlugText from '@/utils/getSlugText.js';
import { Link } from 'react-router-dom';
import { getCategoryKey, getCategoryImage } from '@/utils/category.js';

const CategoriesList = ({
  textColor,
  imageClassName = 'border-4 border-primary-yellow h-40 w-40 xl:h-48 xl:w-48',
  textClassName = 'w-40 text-xs xl:w-48 xl:text-sm',
  gapClassName = 'gap-4 lg:gap-1',
  gridCols = 2,
}) => {
  const { t } = useTranslation();
  const { categories } = useSelector((state) => state.categoryStore);

  const order = ['Turizam i odmor', 'Ugostiteljstvo', 'Vozila, mašine i alati', 'Servisi', 'Nekretnine', 'Razno'];

  const sortedCategories = categories ? [...categories].sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name)) : [];

  return (
    <div
      className={`z-5 mx-auto grid w-full max-w-[450px] grid-cols-${gridCols} items-start sm:max-w-[760px] sm:grid-cols-3 lg:max-w-[1200px] lg:grid-cols-6 ${gapClassName}`}
    >
      {sortedCategories.map((category) => {
        const isRealEstate = category.name === 'Nekretnine';
        const linkTo = isRealEstate ? '/real-estate' : `/products/${getSlugText(t(getCategoryKey(category.name)))}`;

        return (
          <div key={category._id} className='z-5 flex cursor-pointer flex-col items-center justify-center'>
            <Link to={linkTo} onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' })} className='group'>
              <div
                className={`relative rounded-xl bg-cover transition-transform duration-300 group-hover:scale-110 ${imageClassName}`}
                style={{ backgroundImage: `url(${getCategoryImage(category.name)})` }}
              >
                <div className='absolute inset-0 rounded-xl bg-gray-900/40 opacity-0 transition-opacity duration-300 group-hover:opacity-100'></div>
                {isRealEstate && (
                  <span className='absolute right-2 top-2 z-10 rounded bg-black/60 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white'>
                    {t('comingSoon')}
                  </span>
                )}
              </div>
              <div
                className={`inline-block overflow-hidden text-center font-semibold uppercase transition-all duration-300 group-hover:translate-y-1.5 group-hover:scale-110 ${textClassName}`}
                style={{ color: textColor }}
              >
                {t(getCategoryKey(category.name))}
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default CategoriesList;
